import { Box, Donut, Flex, Heading, Image, Text } from "theme-ui";
import CardSkeleton from "../../skeleton/ProjectOverviewCardSkeleton";
import ProjectOverviewIButton from "./ProjectOverviewIButton";
import React from "react";

const ProjectOverviewCard = ({ title, value, meta, loading, colorMode }: any) => {
    if (loading || (value === null || value === undefined)) {
        return <CardSkeleton />
    }

    const bgDashboard = colorMode === 'light' ? "#ffffff" : "#252b36";
    const getDonutValue = () => {
        return Math.min(1, Math.max(0, Number(meta.percentage)) / 100);
    };
    return (
        <Box
            sx={{
                bg: bgDashboard,
                borderRadius: '20px',
                boxShadow: '0px 0px 40px 0px rgba(209, 173, 138, 0.12)',
                p: ["10px", "20px"],
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'space-between',
                alignItems: "flex-start",
                minHeight: ['134px', '230px', '200px', '234px'],
            }}
        >

            <Flex sx={{ justifyContent: 'space-between', alignItems: 'flex-start' }}>
                <Box>
                    <Text sx={{ color: colorMode === 'light' ? '#453521' : '#f8f9fab5', fontSize: ["10px", "12px", "14px", "16px"], fontWeight: 600 }}>{title} <ProjectOverviewIButton description={meta?.description} /></Text>
                </Box>
            </Flex>
            <Flex sx={{ justifyContent: 'space-between', alignItems: 'flex-start' }}>
                <Box>
                    <Heading as="h3" sx={{ fontSize: ["24px", "30px", "40px", "54px",], color: colorMode === 'light' ? '#453521' : '#ffffffeb', fontWeight: 600, }}>{value}</Heading>
                </Box>
            </Flex>

            <Flex sx={{ width: "100%", display: "flex", justifyContent: "space-between", alignItems: 'flex-start', gap: "10px", flexDirection: "column" }}>
                <Flex sx={{ width: "100%", justifyContent: 'space-between', gap: 2 }}>
                    <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
                        <Text sx={{ fontSize: "14px", fontWeight: 600, color: colorMode === 'light' ? '#453521' : '#ece9e9c7' }}>{Math.abs(meta.difference)}</Text>
                        <Image src={meta.arrow} sizes='small' />
                        <Text sx={{
                            display: "flex",
                            justifyContent: "flex-start",
                            fontSize: ["8px", "12px"],
                            backgroundColor: meta?.status === "up" ? "#16A34A1F" : "#EB44441F",
                            color: meta?.status === "up" ? "rgba(22, 163, 74, 1)" : "rgba(235, 68, 68, 1)",
                            borderRadius: "6px",
                            padding: "3px",
                            fontWeight: 500
                        }}
                        >{meta.differencePercentage}</Text>
                    </Box>
                    <Box>
                        <Text sx={{ fontSize: ["8px", "12px"], color: 'rgba(196, 175, 149, 1)', fontWeight: 500 }}>VS. Last Year </Text>
                    </Box>
                </Flex>
                <Flex sx={{ width: "100%", display: "flex", justifyContent: "space-between", alignItems: 'center', }}>
                    <Text sx={{ fontSize: "12px", fontWeight: 500, color: colorMode === 'light' ? '#453521' : '#a9a9a9' }}>{meta.percentage}</Text>
                    <Donut value={getDonutValue()} size={25} strokeWidth={6} />
                </Flex >
            </Flex >
        </Box >
    )
};

export default React.memo(ProjectOverviewCard)